import React from "react";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { Loader } from "@progress/kendo-react-indicators";
import LoadingScreen from "components/common/Loading";
import {
  getLedgerCellValue,
  cellWithBackGround,
  RefCell,
  CenterTextHeaderCell,
} from "./LedgerGridCells";
import {
  DateFormatCell,
  AmountFormatCellEmptyZero,
  AmountFormat,
} from "components/common/formatter";
import excelIcon from "assets/fileIcons/Excel.svg";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { usePreviousTransactions } from "components/common/PreviousTransactions/usePreviousTransactions";
import { GRID_PAGE_SIZES } from "components/common/GridComponents";

const PreviousTransactionsGrid = ({
  isOpen,
  entity,
  title,
  onClose,
  showDDA,
  onExport,
  isExporting,
  handleActionRef,
}) => {
  const { dataState, setDataState, loading, transactions } =
    usePreviousTransactions(isOpen ? entity : null, "matter");

  return (
    <Dialog
      onClose={onClose}
      title={title}
      className="dialog-xxl dialog-title-md"
    >
      <div className="m-4">
        {loading && <LoadingScreen />}
        <Grid
          data={transactions.data}
          total={transactions.total}
          skip={dataState.skip}
          take={dataState.take}
          pageable={{
            buttonCount: 5,
            pageSizes: GRID_PAGE_SIZES,
            previousNext: true,
          }}
          onDataStateChange={(e) => setDataState(e.dataState)}
          style={{
            height: "645px",
          }}
        >
          <GridToolbar>
            <button
              className={`btn p-0 border-0`}
              onClick={() => onExport(true)}
              title="Export to Excel"
              disabled={!transactions.data.length || isExporting}
            >
              <div>
                {isExporting ? (
                  <Loader
                    size="small"
                    type="infinite-spinner"
                    className="text-dark"
                  />
                ) : (
                  <img
                    src={excelIcon}
                    width={18}
                    height={18}
                    alt="Export to Excel"
                  />
                )}
              </div>
            </button>
          </GridToolbar>

          <GridColumn>
            <GridColumn
              field="date"
              title="Date"
              width="100px"
              cell={DateFormatCell}
            />
            <GridColumn field="postingType" title="Type" width="55px" />
            <GridColumn
              field="reference"
              title="Ref"
              width="110px"
              cell={(props) =>
                RefCell({ ...props, isPrevTrans: true }, handleActionRef)
              }
              className="text-wrap"
            />
            <GridColumn
              field="details"
              title="Details"
              width="320px"
              className="text-prewrap"
            />
            <GridColumn
              field="vatAmount"
              title="VAT"
              width="90px"
              headerCell={CenterTextHeaderCell}
              cell={AmountFormatCellEmptyZero}
            />
          </GridColumn>

          <GridColumn title="OFFICE" headerCell={CenterTextHeaderCell}>
            <GridColumn
              field="grossAmount"
              title="Debit"
              headerCell={CenterTextHeaderCell}
              cell={(e) => cellWithBackGround(e, "OFFICE", "Debit")}
              width="95px"
            />
            <GridColumn
              field="grossAmount"
              title="Credit"
              headerCell={CenterTextHeaderCell}
              cell={(e) => cellWithBackGround(e, "OFFICE", "Credit")}
              width="95px"
            />
            <GridColumn
              field="balance"
              title="Balance"
              cell={(e) => cellWithBackGround(e, "OFFICE", "Amount")}
              width="95px"
            />
          </GridColumn>

          <GridColumn title="CLIENT" headerCell={CenterTextHeaderCell}>
            <GridColumn
              field="clientAmount"
              title="Debit"
              headerCell={CenterTextHeaderCell}
              cell={(e) => cellWithBackGround(e, "CLIENT", "Debit")}
              width="95px"
            />
            <GridColumn
              field="clientAmount"
              title="Credit"
              headerCell={CenterTextHeaderCell}
              cell={(e) => cellWithBackGround(e, "CLIENT", "Credit")}
              width="95px"
            />
            <GridColumn
              field="clientBalance"
              title="Balance"
              headerCell={CenterTextHeaderCell}
              cell={(e) => cellWithBackGround(e, "CLIENT", "Amount")}
              width="110px"
            />
          </GridColumn>

          {showDDA && (
            <GridColumn title="DDA" headerCell={CenterTextHeaderCell}>
              <GridColumn
                field="ddaAmount"
                title="Debit"
                headerCell={CenterTextHeaderCell}
                cell={(e) => cellWithBackGround(e, "DDA", "Debit")}
                width="95px"
              />
              <GridColumn
                field="ddaAmount"
                title="Credit"
                headerCell={CenterTextHeaderCell}
                cell={(e) => cellWithBackGround(e, "DDA", "Credit")}
                width="95px"
              />
              <GridColumn
                field="ddaBalance"
                title="Balance"
                headerCell={CenterTextHeaderCell}
                cell={(e) => cellWithBackGround(e, "DDA", "Amount")}
                width="95px"
              />
            </GridColumn>
          )}
        </Grid>
      </div>

      <DialogActionsBar>
        <div className="dialog-footer d-flex justify-content-end">
          <button className="common-btn me-5" onClick={onClose}>
            Close
          </button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};

export default PreviousTransactionsGrid;
